import { render, staticRenderFns } from "./Injuries.vue?vue&type=template&id=67a7a7e2"
import script from "./Injuries.vue?vue&type=script&lang=js"
export * from "./Injuries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports